import Section from "./Section";
import '../styles/Section.css';
import {projects} from '../datas/projects.js';
import Button from "./Button";
import '../styles/ClientItem.css';
import ButtonNext from "./ButtonNext";

function ProjectsPage() {
  var list = [];
  const projectsSorted = projects.sort((a,b) => (a.year < b.year) ? 1 : ((b.year < a.year) ? -1 : 0));
  for(let i = 0; i < projects.length; i++) {
    list.push(
    <Section id={i} negate={i%2?1:0}>
      <div className="d-section-center">
        <div className="d-section-text">
          <h1>{projectsSorted[i].name}</h1>
          <h3>{projects[i].year}</h3>
          <p>{projectsSorted[i].description}</p>
         {projectsSorted[i].client ? 
          <a href={projectsSorted[i].client_url} target="_blank" rel="noreferrer">
            <h3>Client: {projectsSorted[i].client}</h3>
            <img className="d-client-item" src={`clients/${projectsSorted[i].client}.png`} alt="" />
          </a>  : ""}
          {projectsSorted[i].url && <a href={projects[i].url} target="_blank" rel="noreferrer"><Button>Website</Button></a>}
        </div>
        {projectsSorted[i].logo && <img className="d-section-illustration" src={`logo/${projects[i].logo}`} alt=""/>}
      </div>
      {i < projects.length-1 && <ButtonNext href={`#${i+1}`}/>}
    </Section>
    );
  }
  return list;
}


export default ProjectsPage;